// src/data/palyazatokData.js

export const palyazatok = [
  {
    id: "kap-rd04a-rd04b-2-24",
    slug: "kap-rd04a-rd04b-2-24",
    title: "Tésztaüzem technológiai fejlesztése",
    shortDescription:
      "A projekt célja a tésztaüzem korszerűsítése, technológiai és energetikai fejlesztése, valamint a működés hatékonyságának növelése.",
    image: "../images/KAP2.png",
    heroImage: "../images/palyazat.png",
    supportImageTop: "../images/KAP.png",
    supportImageBottom: "../images/KAP2.png",
    details: [
      ["Kedvezményezett neve:", "Nyír-Aranytojás Kereskedelmi Termelő és Szolgáltató Kft."],
      ["Projekt címe:", "Tésztaüzem technológiai fejlesztése"],
      ["Azonosító száma:", "KAP-RD04a-RD04b-2-24"],
      [
        "Szerződött támogatás összege:",
        "42 548 464 Ft, azaz negyvenkettőmillió-ötszáznegyvennyolcezer-négyszázhatvannégy forint",
      ],
      ["Támogatás mértéke:", "50 %"],
      [
        "A projekt tartalma:",
        "A Nyír-Aranytojás Kereskedelmi Termelő és Szolgáltató Korlátolt Felelősségű Társaság, 4543 Laskod, Szabadság utca 31. alatti 165/3 hrsz ingatlanon megvalósul a Tésztaüzem energetikai fejlesztése, ezen belül a külső homlokzat 15 cm grafit EPS szigetelést kap. A projekt keretében a támogatásnak köszönhetően beszerzésre kerül 1 db Áruszállító jármű, 1 db Csomagológép és 1 db Targonca. A projekt hozzájárul a cég korszerű és hatékony működéséhez, a modern gyártó technológia bevezetéséhez. A projekt eredmények, az Uniótól kapott pénzügyi támogatásnak köszönhetően valósulnak meg.",
      ],
      ["A projekt tervezett befejezési dátuma:", "2026.05.31."],
    ],
  },
  {
    id: "kkv-technologia-plusz",
    slug: "kkv-technologia-plusz",
    title: "Technológiai fejlesztés a KKV Technológia Plusz Hitelprogram keretében",
    shortDescription:
      "A társaság újabb fejlesztési projektje a KKV Technológia Plusz Hitelprogram segítségével valósul meg.",
    image: "/images/kkvtechnologia.png",
    heroImage: "/images/palyazat.png",
    supportImageTop: "/images/KAP.png",
    supportImageBottom: "/images/kkvtechnologia.png",
    details: [
      ["Kedvezményezett neve:", "Nyír-Aranytojás Kereskedelmi Termelő és Szolgáltató Kft."],
      ["Projekt címe:", "Technológiai fejlesztés"],
      ["Program neve / azonosítója:", "KKV Technológia Plusz Hitelprogram B_LFH"],
      // ["Szerződés aláírásának dátuma:", "2026.03.13."],
      //   ["Kommunikációs kötelezettség teljesítésének határideje:", "2026.04.12."],
      //   ["Tájékoztatás fenntartásának időtartama:", "Legalább 3 év"],
      ["Szerződött vissza nem térítendő támogatás összege:", "0.-Ft"],
      ["Szerződött visszatérítendő támogatás összege:", "50.000.000.-Ft"],
      ["A fejlesztés célja:", "Munkaerő és energiaköltségek finanszírozása a Nyír-Aranytojás Kft.-nél."],
      ["A fejlesztés tartalma:", "Az igényelt kölcsönösszeggel a gyorsan változó környezet megnövekedett energiaköltségeit kívánjuk finanszírozni az MFB Zrt.-től felvett kölcsönnel, továbbá az előmunka költségeinek egy részét is ezzel a programmal kívánjuk elszámolni. A megítélt pályázati összeg lényegesen hozzájárul cégünk versenyképességéhez valamint értékeinek, tevékenységének megörzéséhez."],
      ["A projekt tervezett befejezési dátuma:", "2027.01.11."],
      [
        "Tájékoztatási mondat:",
        "A projekt az Európai Unió támogatásával, a magyar állam társfinanszírozásával valósul meg.",
      ],
    ],
  },
];